module.exports = __webpack_public_path__ + "static/media/  (123).3757df4c.jpg";